 function initThemeAccessibility() {


  // JS FOR BUTTON IN GALLERY MEDIA PRODUCT 
  document.querySelectorAll('.product__media-toggle.quick-add-hidden.product__media-zoom-lightbox').forEach(btn => {
  btn.setAttribute('tabindex', '-1');
});



   // JS for swatches color 
   document.querySelectorAll('label.swatches__form--label').forEach(function (l) {
  if (!l.textContent.trim()) {
    var input = document.getElementById(l.getAttribute('for'));
    var s = document.createElement('span');
    s.className = 'visually-hidden';
    s.textContent = input ? input.getAttribute('aria-label') : '';
    l.appendChild(s);
    }
   });
     // =====================================================// Helpers
document.querySelectorAll('a[href]').forEach((link) => {
  const url = new URL(link.href, window.location.href);

  if (url.origin !== window.location.origin) {
    const existingLabel = link.getAttribute("aria-label");
    const label = existingLabel || link.textContent.trim();

    link.setAttribute(
      "aria-label",
      `${label} - Redirecting to Third-Party website`
    );
  }
});


// aria-hidden true img 
function applyAriaHiddenToContrastImages() {
  document.querySelectorAll('[data-contrast="none"] img').forEach((img) => {
    img.setAttribute("aria-hidden", "true");
  });
}

applyAriaHiddenToContrastImages();


  // ============================================================ Js for swatches warning for color changes
  document.addEventListener("change", function (event) {
  const radio = event.target.closest(".swatches__form--input");

  if (!radio) return;

  const swatches = radio.closest(".swatches");
  if (!swatches) return;

  const swatchElement = radio.closest(".js-swatch-element");

  // Trigger the existing swatch behavior
  if (swatchElement) {
    const label = swatchElement.querySelector(
      ".swatches__form--label"
    );

    if (label) {
      label.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    }
  }

  // Screen reader announcement
  const message = swatches
    .closest(".product-card__itemColorSwatches")
    ?.querySelector(".swatches__selection-message");

  if (!message) return;

  const optionName = swatches.dataset.optionName || "option";
  const selectedValue = radio.value;

  message.textContent = "";

  requestAnimationFrame(() => {
    message.textContent =
      optionName.charAt(0).toUpperCase() +
      optionName.slice(1) +
      " changed to " +
      selectedValue +
      ". Product information has been updated.";
  });
});
  // =====================================================  JS  for readmore in join-us page
  (function () {
    const buttons = document.querySelectorAll(".ReadMoreButton");

    buttons.forEach((button) => {
      button.setAttribute("aria-expanded", "false");

      button.addEventListener("click", function () {
        const isExpanded = this.getAttribute("aria-expanded") === "true";

        this.setAttribute("aria-expanded", String(!isExpanded));

        this.textContent = isExpanded ? "Read More" : "Read Less";
      });
    });
  })();

 

  // =====================================================
  // Cart Accessibility
  // =====================================================

  function initCartAccessibility() {
    const cartDrawer = document.querySelector(".cart-slide-in");

    // The drawer is rendered by React, so it can be missing on this pass. Wait for it instead of dropping the cart fixes for the whole page.

    if (!cartDrawer) {
      const pending = new MutationObserver(() => {
        if (document.querySelector(".cart-slide-in")) {
          pending.disconnect();

          initCartAccessibility();
        }
      });

      pending.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return;
    }

    const triggerSelector =
      "[data-cart-toggle-button], [data-add-to-cart-button]";

    let lastFocusedTrigger = null;
    let drawerOpen = false;

    const getCloseButton = () =>
      cartDrawer.querySelector(".cart-header__close-cart-button");

    const getFocusableElements = () => [
      ...cartDrawer.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])',
      ),
    ];

    //   Initialize trigger buttons

    document.querySelectorAll(triggerSelector).forEach((button) => {
      button.setAttribute("aria-haspopup", "dialog");
    });

    //  Update cart item controls

    function updateCartLabels() {
      cartDrawer.querySelectorAll(".cart-line-item").forEach((item) => {
        const productTitle = item
          .querySelector(".cart-line-item__title")
          ?.textContent.trim();

        if (!productTitle) return;

        const quantityButtons = item.querySelectorAll(
          ".cart-line-item__quantity-action-btn",
        );

        quantityButtons[0]?.setAttribute(
          "aria-label",
          `Decrease ${productTitle} quantity by one`,
        );

        quantityButtons[1]?.setAttribute(
          "aria-label",
          `Increase ${productTitle} quantity by one`,
        );

        item
          .querySelector(".cart-line-item__remove-btn")
          ?.setAttribute("aria-label", `Remove ${productTitle} from cart`);

        // Add accessible price label
        const priceElement = item.querySelector(".cart-line-item__price");

        if (
          priceElement &&
          !priceElement.previousElementSibling?.classList.contains(
            "price-label",
          )
        ) {
          const priceLabel = document.createElement("span");

          priceLabel.className = "visually-hidden price-label";
          priceLabel.textContent = "Price:";

          priceElement.parentNode.insertBefore(priceLabel, priceElement);
        }
      });
    }

    /*
    The closed drawer is only pushed off screen with a transform, so it stays in the accessibility tree while the cart is shut. Hide it from
    assistive tech and from tabbing until it actually opens.
  */
    let closePending = false;

    function setDrawerHidden(hidden) {
      if (hidden) {
        cartDrawer.setAttribute("aria-hidden", "true");

        // inert also keeps the closed drawer out of the tab order.
        cartDrawer.setAttribute("inert", "");
      } else {
        cartDrawer.removeAttribute("aria-hidden");

        cartDrawer.removeAttribute("inert");
      }
    }

    /*
    Move focus into the drawer after the third party render.

    The drawer is rendered by React, so the header (and with it the
    close button) can be replaced while we are focusing it.
  */
    let focusGuardTimer = null;
    let focusGuardDeadline = 0;

    const focusTarget = () => getCloseButton() || cartDrawer;

    function focusIntoDrawer() {
      if (!drawerOpen) return;

      const target = focusTarget();

      if (!target) return;

      // The drawer itself is focusable as a last resort only.
      cartDrawer.setAttribute("tabindex", "-1");

      target.focus({
        preventScroll: true,
      });
    }

    /*
    Focus was lost (not moved by the user) when nothing, or only the
    body, holds it 
  */
    function focusWasLost() {
      const active = document.activeElement;

      if (!active || active === document.body) return true;

      if (cartDrawer.contains(active)) return false;

      return active === lastFocusedTrigger;
    }

    function startFocusGuard() {
      focusGuardDeadline = Date.now() + 4000;

      focusIntoDrawer();

      if (focusGuardTimer) return;

      focusGuardTimer = setInterval(() => {
        if (!drawerOpen || Date.now() > focusGuardDeadline) {
          stopFocusGuard();

          return;
        }

        if (focusWasLost()) {
          focusIntoDrawer();
        }
      }, 100);
    }

    function stopFocusGuard() {
      if (focusGuardTimer) {
        clearInterval(focusGuardTimer);

        focusGuardTimer = null;
      }
    }

    function openDrawer() {
      if (drawerOpen) return;

      drawerOpen = true;

      closePending = false;

      // Must come before focus is moved in: focus cannot land inside an
      // aria-hidden / inert subtree.
      setDrawerHidden(false);

      cartDrawer.setAttribute("role", "dialog");

      cartDrawer.setAttribute("aria-modal", "true");

      if (!cartDrawer.getAttribute("aria-label")) {
        // The heading carries the live item count -- "My Bag (3)" -- and
        // the label is set once, so drop the count to keep it accurate.
        cartDrawer.setAttribute(
          "aria-label",
          cartDrawer
            .querySelector(".cart-header__title")
            ?.textContent.trim()
            .replace(/\s*\(\s*\d+\s*\)\s*$/, "") || "My Bag",
        );
      }

      if (lastFocusedTrigger) {
        lastFocusedTrigger.setAttribute("aria-expanded", "true");
      }

      updateCartLabels();

      startFocusGuard();
    }

    function closeDrawer() {
      if (!drawerOpen) return;

      drawerOpen = false;

      stopFocusGuard();

      cartDrawer.removeAttribute("tabindex");

      closePending = true;

      if (lastFocusedTrigger) {
        lastFocusedTrigger.setAttribute("aria-expanded", "false");
      }

      setTimeout(() => {
        if (lastFocusedTrigger) {
          lastFocusedTrigger.focus({
            preventScroll: true,
          });
        }

        /*
        The opening control can be gone or disabled by the time the
        drawer closes (a sold out variant, a re-rendered card), and
        focus would then fall to the top of the page. Send it to the
        header cart button instead.
      */
        if (document.activeElement !== lastFocusedTrigger) {
          document.querySelector("[data-cart-toggle-button]")?.focus({
            preventScroll: true,
          });
        }

        // Never hide a subtree that still holds focus.
        if (cartDrawer.contains(document.activeElement)) {
          document.activeElement.blur();
        }

        closePending = false;

        if (!drawerOpen) setDrawerHidden(true);
      }, 300);
    }

    /*
    Focus trap + Escape
  */
    cartDrawer.addEventListener("keydown", function (event) {
      if (!drawerOpen) return;

      if (event.key === "Escape") {
        getCloseButton()?.click();

        return;
      }

      if (event.key !== "Tab") return;

      const focusable = getFocusableElements();

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();

        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();

        first.focus();
      }
    });

    /*
    Observe third party drawer changes
  */
    new MutationObserver(() => {
      const isOpen = cartDrawer.classList.contains("cart-slide-in--open");

      if (isOpen) {
        openDrawer();
      } else {
        closeDrawer();

        // Re-assert it if a re-render drops the attributes, but not
        // while the closing hand-off is still moving focus out.
        if (!closePending && !cartDrawer.hasAttribute("aria-hidden")) {
          setDrawerHidden(true);
        }
      }

      updateCartLabels();
    }).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });

    // Initial state: the drawer is closed on every page load.
    if (!cartDrawer.classList.contains("cart-slide-in--open")) {
      setDrawerHidden(true);
    }

    // The backdrop is decorative and only exists to be clicked.
    document
      .querySelector(".cart-background")
      ?.setAttribute("aria-hidden", "true");

    // Initial scan
    updateCartLabels();
  }

  initCartAccessibility();

  ///////////===================== Mega menu functionality starts
  function updateDesktopClass() {
    document.querySelectorAll(".main_nav__link-items").forEach((element) => {
      if (window.matchMedia("(min-width: 1024px)").matches) {
        element.classList.add("desktop-only");
      } else {
        element.classList.add("mobile-only");
      }
    });
  }

  updateDesktopClass();
  window.addEventListener("resize", updateDesktopClass);

  /* =========================================================
   * NAVIGATION MODE
   * ======================================================= */

  (function () {
    "use strict";

    const DESKTOP_WIDTH = 1024;

    function updateNavigationMode() {
      const isDesktop = window.matchMedia(
        `(min-width: ${DESKTOP_WIDTH}px)`,
      ).matches;

      document
        .querySelectorAll(".main_nav__link-items")
        .forEach(function (element) {
          element.classList.toggle("desktop-only", isDesktop);
          element.classList.toggle("mobile-only", !isDesktop);
        });
    }

    updateNavigationMode();

    let resizeFrame = null;

    window.addEventListener("resize", function () {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(function () {
        updateNavigationMode();
        resizeFrame = null;
      });
    });
  })();
  /* =========================================================
   * DESKTOP MEGA MENU ACCESSIBILITY
   * ======================================================= */
  (function () {
    "use strict";

    const BREAKPOINT = 1024;
    const TRIGGER =
      ".desktop-only ul.nav-item__primary-list > li.nav-item.has-children > a[data-first-level-link][data-sublink-toggle]";
    const MENU = "[data-mega-menu-id]";

    const triggers = () => document.querySelectorAll(TRIGGER);

    const getMenu = (trigger) => {
      const id = trigger.getAttribute("data-link-id");
      return id
        ? document.querySelector(
            `${MENU}[data-mega-menu-id="${CSS.escape(id)}"]`,
          )
        : null;
    };

    const isOpen = (trigger) => getMenu(trigger)?.classList.contains("active");

    function sync() {
      if (window.innerWidth < BREAKPOINT) return;

      triggers().forEach((trigger) => {
        const menu = getMenu(trigger);
        if (!menu) return;

        trigger.removeAttribute("href");
        trigger.setAttribute("role", "button");
        trigger.setAttribute("tabindex", "0");
        trigger.setAttribute(
          "aria-expanded",
          String(menu.classList.contains("active")),
        );

        if (menu.id) {
          trigger.setAttribute("aria-controls", menu.id);
        }
      });
    }

    function closeOthers(current) {
      triggers().forEach((trigger) => {
        if (trigger !== current && isOpen(trigger)) {
          trigger.click();
        }
      });
    }

    /* Click */
    document.addEventListener("click", (event) => {
      if (window.innerWidth < BREAKPOINT) return;

      const trigger = event.target.closest(TRIGGER);
      if (!trigger) return;

      requestAnimationFrame(() => {
        if (isOpen(trigger)) closeOthers(trigger);
        sync();
      });
    });

    /* Keyboard */
    document.addEventListener("keydown", (event) => {
      if (window.innerWidth < BREAKPOINT) return;

      const trigger = event.target.closest(TRIGGER);
      if (!trigger) return;

      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        trigger.click();

        requestAnimationFrame(() => {
          if (isOpen(trigger)) closeOthers(trigger);
          sync();
        });
      }
    });

    // Escape close
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || window.innerWidth < BREAKPOINT) {
        return;
      }

      const openTrigger = [...triggers()].find((trigger) => isOpen(trigger));

      if (openTrigger) {
        openTrigger.click();

        requestAnimationFrame(() => {
          sync();
          openTrigger.focus();
        });
      }
    });

    /* Outside click */
    document.addEventListener("click", (event) => {
      if (window.innerWidth < BREAKPOINT) return;

      if (event.target.closest(".desktop-only") || event.target.closest(MENU))
        return;

      triggers().forEach((trigger) => {
        if (isOpen(trigger)) trigger.click();
      });
    });

    // /* Scroll */
    // window.addEventListener(
    //   "scroll",
    //   () => {
    //     if (window.innerWidth < BREAKPOINT) return;

    //     triggers().forEach((trigger) => {
    //       if (isOpen(trigger)) trigger.click();
    //     });
    //   },
    //   { passive: true },
    // );
let lastScrollY = window.scrollY;
const SCROLL_THRESHOLD = 750; // px

window.addEventListener(
  "scroll",
  () => {
    if (window.innerWidth < BREAKPOINT) return;

    const currentScrollY = window.scrollY;

    if (Math.abs(currentScrollY - lastScrollY) >= SCROLL_THRESHOLD) {
      triggers().forEach((trigger) => {
        if (isOpen(trigger)) trigger.click();
      });

      lastScrollY = currentScrollY;
    }
  },
  { passive: true }
);

    /* Watch .active */
    new MutationObserver((mutations) => {
      if (window.innerWidth < BREAKPOINT) return;

      if (mutations.some((m) => m.target.matches?.(MENU))) {
        sync();
      }
    }).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    sync();
  })();

  // ========================================================= MOBILE / TABLET MENU ACCESSIBILITY
  (function () {
  "use strict";

  const nav = document.querySelector("nav.mobile-only");
  const burger = document.querySelector(".hamburger-btn");
  const closeBtns = document.querySelectorAll(".close-btn, button.nav-item--close");
  if (!nav || !burger || !closeBtns.length) return;

  const FOCUSABLE =
    "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";
  const MARK = "data-trap-inert";

  let lastFocused = null;
  let active = null; // currently open first-level screen

  const menuOf = (id) => nav.querySelector(`[data-mega-menu-id="${id}"]`);
  const triggerOf = (id) =>
    nav.querySelector(`[data-first-level-link][data-link-id="${id}"]`);

  function getFocusable(container) {
    return [...container.querySelectorAll(FOCUSABLE)].filter(
      (el) =>
        el.getClientRects().length &&
        !el.closest("[inert]") &&
        !el.closest('[aria-hidden="true"]:not(nav)')
    );
  }

  // Everything outside the active screen becomes inert (blocks Tab, swipe, clicks)
  function updateInert() {
    nav.querySelectorAll(`[${MARK}]`).forEach((el) => {
      el.removeAttribute("inert");
      el.removeAttribute(MARK);
    });
    let node = active;
    while (node && node !== nav) {
      const parent = node.parentElement;
      if (!parent) break;
      [...parent.children].forEach((sib) => {
        if (sib !== node && !sib.hasAttribute("inert")) {
          sib.setAttribute("inert", "");
          sib.setAttribute(MARK, "");
        }
      });
      node = parent;
    }
  }

  function openMenu(link, menu) {
    // close other first-level screens
    nav.querySelectorAll("[data-first-level-link][aria-expanded='true']").forEach((o) => {
      o.setAttribute("aria-expanded", "false");
      menuOf(o.dataset.linkId)?.setAttribute("aria-hidden", "true");
    });

    active = menu;
    link.setAttribute("aria-expanded", "true");
    menu.setAttribute("aria-hidden", "false");

    // Back button is not an expandable control
    const back = menu.querySelector(".mega-menu__previous-level");
    back?.removeAttribute("aria-expanded");
    back?.removeAttribute("role");

    updateInert();
    requestAnimationFrame(() => (back || getFocusable(menu)[0])?.focus());
  }

  function closeMenu(menu, restoreFocus = true) {
    if (!menu) return;
    const trigger = triggerOf(menu.dataset.megaMenuId);
    menu.setAttribute("aria-hidden", "true");
    trigger?.setAttribute("aria-expanded", "false");
    active = null;
    updateInert(); // must run BEFORE focus()
    if (restoreFocus) trigger?.focus();
  }

  /* ---------- Links (first + second level) ---------- */

  nav
    .querySelectorAll(
      "[data-first-level-link][data-sublink-toggle], [data-second-level-link][data-sublink-toggle]:not(.mega-menu__previous-level)"
    )
    .forEach((link) => {
      const menu = menuOf(link.dataset.linkId);
      if (!menu) return;

      link.setAttribute("role", "button");
      link.setAttribute("tabindex", "0");

      // Enter works on <a>, Space does not
      link.addEventListener("keydown", (e) => {
        if (e.key === " ") {
          e.preventDefault();
          link.click();
        }
      });

      if (link.hasAttribute("data-second-level-link")) {
        // Theme controls the accordion; we only keep ARIA in sync
        const sync = () => {
          const open = menu.classList.contains("active");
          link.setAttribute("aria-expanded", String(open));
          menu.setAttribute("aria-hidden", String(!open));
          menu.toggleAttribute("inert", !open);
        };
        sync();
        new MutationObserver(sync).observe(menu, {
          attributes: true,
          attributeFilter: ["class"],
        });
        link.addEventListener("click", () => setTimeout(sync, 0));
        return;
      }

      // First level: our JS controls it
      link.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-hidden", "true");
      link.addEventListener("click", () => {
        link.getAttribute("aria-expanded") === "true"
          ? closeMenu(menu, false)
          : openMenu(link, menu);
      });
    });

  /* ---------- Back buttons ---------- */

  nav.querySelectorAll(".mega-menu__previous-level").forEach((btn) => {
    const menu = btn.closest("[data-mega-menu-id]");
    btn.removeAttribute("aria-expanded");
    btn.removeAttribute("role");
    if (!btn.hasAttribute("aria-label")) {
      const name = triggerOf(menu?.dataset.megaMenuId)?.textContent.trim();
      btn.setAttribute("aria-label", name ? `Back to ${name}` : "Back to previous menu");
    }
    btn.addEventListener("click", () => closeMenu(menu));
  });

  /* ---------- Mobile dialog ---------- */

  nav.setAttribute("role", "dialog");
  nav.setAttribute("aria-modal", "true");
  nav.setAttribute("aria-hidden", "true");
  nav.setAttribute("inert", "");
  burger.setAttribute("aria-expanded", "false");

  function openMobile() {
    lastFocused = document.activeElement;
    nav.removeAttribute("inert");
    nav.setAttribute("aria-hidden", "false");
    burger.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() =>
      (nav.querySelector(".close-btn") || getFocusable(nav)[0])?.focus()
    );
  }

  function closeMobile() {
    closeMenu(active, false); // reset so it reopens at top level
    nav.setAttribute("aria-hidden", "true");
    nav.setAttribute("inert", "");
    burger.setAttribute("aria-expanded", "false");
    lastFocused?.focus();
  }

  burger.addEventListener("click", openMobile);
  closeBtns.forEach((b) => b.addEventListener("click", closeMobile));

  /* ---------- Esc + focus trap ---------- */

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || nav.getAttribute("aria-hidden") === "true") return;
    active ? closeMenu(active) : closeMobile();
  });

  nav.addEventListener("keydown", (e) => {
    if (e.key !== "Tab") return;
    const container = active || nav;
    const items = getFocusable(container);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];
    const cur = document.activeElement;

    if (!container.contains(cur)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && cur === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && cur === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();










  // cart empty image 
  (function () {
  function fix() {
    document.querySelectorAll('.empty-cart-image').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
  }
  fix();
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();
  ///////////// Size guide Collapse expand ================================================================
  function sizeGuideModalAccessibility() {
    const button = document.querySelector("[data-modal-button]");
    const modal = document.querySelector("#product-modal--size-guide");

    if (!button || !modal) return;

    const observer = new MutationObserver(() => {
      const isOpen = modal.getAttribute("data-open") === "true";

      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ["data-open"],
    });
  }

  sizeGuideModalAccessibility();

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const openModal = document.querySelector('[data-open="true"]');

      if (openModal) {
        openModal.setAttribute("data-open", "false");
      }
    }
  });

  ///================ Size Guide  popup tabs ===========================================
  document.addEventListener("click", function (event) {
    const clickedTab = event.target.closest(".size-chart-modal-tab");

    if (!clickedTab) return;

    const tabs = document.querySelectorAll(".size-chart-modal-tab");
    const panels = document.querySelectorAll('[role="tabpanel"]');

    const targetPanelId = clickedTab.getAttribute("aria-controls");

    // Update tabs state
    tabs.forEach((tab) => {
      const isActive = tab === clickedTab;

      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    // Update panels state
    panels.forEach((panel) => {
      const isActive = panel.id === targetPanelId;

      if (isActive) {
        panel.removeAttribute("hidden");
        panel.setAttribute("tabindex", "0");
      } else {
        panel.setAttribute("hidden", "");
        panel.setAttribute("tabindex", "-1");
      }
    });
  });

  ///////////////////////////// Size guide convert to inches centimeter announcement ======================

  ///////////////////// Missing alternative text on card images
  function baseImageUrl(url) {
    if (!url) return "";
    return url.split("?")[0]; // strips version + width params
  }

  function findColorForImage(img, card) {
    var imgBase = baseImageUrl(img.getAttribute("src"));
    if (!imgBase || !card) return "";

    var swatches = card.querySelectorAll("[data-swatch-color-raw]");
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      var mainUrl = baseImageUrl(sw.getAttribute("data-variant-image"));
      var hoverUrl = baseImageUrl(sw.getAttribute("data-variant-image-hover"));
      if (
        (mainUrl && mainUrl === imgBase) ||
        (hoverUrl && hoverUrl === imgBase)
      ) {
        return sw.getAttribute("data-swatch-color-raw") || "";
      }
    }

    // fallback: try data-index match if src match fails
    var index = img.getAttribute("data-index");
    if (index !== null) {
      var swatchByIndex = card.querySelector(
        '[data-swatch-color-raw][data-index="' + index + '"]',
      );
      if (swatchByIndex)
        return swatchByIndex.getAttribute("data-swatch-color-raw") || "";
    }
    return "";
  }

  function fixMissingAlt(img) {
    var current = img.getAttribute("alt");
    if (current && current.trim() !== "") return; // already has alt, skip

    var card = img.closest(".product-card") || img.closest("product-card");
    var titleEl = card ? card.querySelector(".product-card__itemTitle") : null;
    var productTitle = titleEl ? titleEl.textContent.trim() : "Product";

    var colorName = findColorForImage(img, card);

    img.setAttribute(
      "alt",
      colorName ? productTitle + " - " + colorName : productTitle,
    );
  }

  function scanAllDynamicImages() {
    document
      .querySelectorAll(
        ".main-images img, .product-card__img-wrapper--hidden img",
      )
      .forEach(fixMissingAlt);
  }

  // 1. Fix images already on page
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAllDynamicImages);
  } else {
    scanAllDynamicImages();
  }

  // 2. Watch for images added later (hover, swatch click, etc.)
  var altFixObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          node.tagName === "IMG" &&
          (node.closest(".main-images") ||
            node.closest(".product-card__img-wrapper--hidden"))
        ) {
          fixMissingAlt(node);
        } else if (node.querySelectorAll) {
          node
            .querySelectorAll(
              ".main-images img, .product-card__img-wrapper--hidden img",
            )
            .forEach(fixMissingAlt);
        }
      });
    });
  });

  altFixObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

/*
  This file is loaded with `async`, so it can execute after
  DOMContentLoaded has already fired -- in which case a
  DOMContentLoaded listener never runs and none of the accessibility
  fixes in this file are applied. Run straight away when the document
  is already parsed.
*/
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initThemeAccessibility);
} else {
  initThemeAccessibility();
}
